import React from 'react';
import PropTypes from 'prop-types';
import CurrencyInput from '../../utils/rewrotedReactCurrencyInput';
import UiComponent from '../UiComponent';

export default class Currency extends UiComponent {

  constructor(props) {
    super(props);
    this.state = {
      amount: props.forceUpdate && props.field.value ? parseFloat(props.field.value) : 0
    };
    this.getPrefix = this.getPrefix.bind(this);
    this.changeValue = this.changeValue.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if ((this.state.amount === 0 && nextProps.field.value && nextProps.field.value.length > 0) ||
      nextProps.forceUpdate && String(this.props.field.value) !== String(nextProps.field.value)) {
      this.setState({
        amount: parseFloat(nextProps.field.value),
      });
    }
  }

  changeValue(value){
    this.props.field.value = value
    this.props.onChange(this.props.field.name, this.props.field);
    this.setState( { amount: value } );
  }

  getPrefix() {
    return this.props.field.prefix || null;
  }

  render() {
    const { additionalComponentNearTitle } = this.props;
    const containerClass = `form-group ${this.props.className}`;
    let prefixContainer = null;

    if(this.props.field.prefix) {
      prefixContainer = (
        <span className="input-group-addon currency-prefix">
          {this.getPrefix()}
        </span>
      )
    }
    return (
      <div className={containerClass}>
        {this.getLabel()} {additionalComponentNearTitle}
        <div className="input-group">

          {prefixContainer}

          <CurrencyInput
            name = "myInput"
            className = "form-control currency-value"
            placeholder = "Add value"
            value={this.state.amount}
            onChangeEvent={ (e) => this.changeValue(e.target.value) }
            decimalSeparator="."
            thousandSeparator=","
            precision="2"
            autoFocus={false}
            disabled={this.props.disabled}
          />
        </div>
        {this.getErrors()}
      </div>
    );
  }
}

Currency.propTypes = {
  field: PropTypes.object,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  additionalComponentNearTitle: PropTypes.object,
  forceUpdate: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/common/Currency/index.js